import { render, staticRenderFns } from "./inactive-application.component.vue?vue&type=template&id=4f590d9a&"
import script from "./inactive-application.component.ts?vue&type=script&lang=ts&"
export * from "./inactive-application.component.ts?vue&type=script&lang=ts&"
import style0 from "./inactive-application.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports